import React from 'react';
import { Box } from '@mui/material';
import { Cancel as CancelIcon, Save as SaveIcon } from '@mui/icons-material';

import { FixedFooter } from '@/components/footer/fixed-footer';

export interface FormActionFooterProps {
  isSubmitting: boolean;
  isSubmitDisabled: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  cancelLabel?: string;
  submitLabel?: string;
  submittingLabel?: string;
  hasNavigationPanel?: boolean;
}

export const FormActionFooter: React.FC<FormActionFooterProps> = ({
  isSubmitting,
  isSubmitDisabled,
  onCancel,
  onSubmit,
  cancelLabel = 'キャンセル',
  submitLabel = '入力内容を決定',
  submittingLabel = '登録中...',
  hasNavigationPanel = true,
}) => {
  return (
    <>
      {/* Add bottom padding to prevent content from being hidden behind fixed footer */}
      <Box sx={{ height: '100px' }} />
      {/* Fixed Action Footer */}
      <FixedFooter
        buttons={[
          {
            label: cancelLabel,
            onClick: onCancel,
            variant: 'outlined',
            startIcon: <CancelIcon />,
            disabled: isSubmitting,
            sx: {
              marginLeft: 'auto',
            },
          },
          {
            label: isSubmitting ? submittingLabel : submitLabel,
            onClick: onSubmit,
            variant: 'contained',
            startIcon: <SaveIcon />,
            disabled: isSubmitDisabled,
            loading: isSubmitting,
          },
        ]}
        isSubmitting={isSubmitting}
        hasNavigationPanel={hasNavigationPanel}
      />
    </>
  );
};
